import {
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth/services/auth.service';

@Injectable({ providedIn: 'root' })
export class HeadersInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.authService.accessToken}`,
        });

        return next.handle(req.clone({ headers }));
    }
}
